import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { DetailsConfig } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/details/interfaces/details-config.interface';
import { DisplayServiceProvider } from '../../../core/services/display-service/display-service';
import { FormControl, FormGroup } from '@angular/forms';
import { FormField } from '../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { HttpClient } from '@angular/common/http';
import { IClientModel } from '../../../clients/interfaces/i-client-model.interface';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { Task } from '../../interfaces/task.interface';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';

@IonicPage()
@Component({
  selector: 'page-task-details',
  templateUrl: 'task-details.html',
})
export class TaskDetailsPage implements OnInit {
  public userTask: any;
  public task: Task;
  public client: IClientModel;
  public questionnaire: FormField[];
  public questionnaireForm: FormGroup;
  public isEndButtonDisabled: boolean = false;
  public config: DetailsConfig;
  public db: any;
  public screenData: any;

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private viewCtrl: ViewController,
    public textService: TextServiceProvider,
    private displayService: DisplayServiceProvider,
    public configService: ConfigServiceProvider,
    private storageService: StorageServiceProvider,
    private http: HttpClient,
  ) {
    this.task = this.navParams.get('task');
    this.screenData = {
      ...this.task,
      canDisplayRepresentative: !!this.task.representative_id,
      canDisplayRealizedBy: !!this.task.realized_by,
    };
  }

  ngOnInit() {
    this.config = this.displayService.getScreenComponent('task-details', 'task-details');
    this.db = this.storageService.db;
  }

  close() {
    this.navCtrl.pop();
  }

  ionViewDidEnter() {
    this.http
      .get(this.configService.getEngineUrl('tasks'), {
        params: { businessKey: this.task.id },
      })
      .subscribe((userTask: any) => {
        if (userTask.content && userTask.content.length > 0) {
          this.userTask = userTask.content[0];
          this.questionnaire = JSON.parse(this.userTask.formJson);
        }
      });
  }

  public submit() {
    if (this.questionnaireForm && this.questionnaireForm.valid) {
      this.questionnaireForm.addControl('last_modification_date', new FormControl(moment().format('DD-MM-YYYY')));
      this.isEndButtonDisabled = true;
      const url = this.configService.getEngineUrl('endTask').replace('{taskId}', this.userTask.id);

      const finishUserTaskPost = this.http.post(url, {
        action: 'complete',
        variables: this.questionnaireForm.getRawValue(),
      });

      this.viewCtrl.dismiss(finishUserTaskPost).catch((err) => console.error(err));
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/tasks/pages/task-details/task-details.ts